import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unique'
})
export class UniquePipe implements PipeTransform {

  transform(value: any[], key?: string, ignoreEmpty: boolean = false): any[] {
    const output: any = [];
    for (let i = 0; i < (value || []).length; i++) {
      const item = key ? value[i][key] : value[i];

      if (output.indexOf(item) === -1) {
        if (ignoreEmpty && (item === '' || item === undefined || item === null)) {
          continue;
        }
        output.push(item);
      }
    }
    return output;
  }

}

@NgModule({
  imports: [],
  declarations: [UniquePipe],
  exports: [UniquePipe]
})
export class UniquePipeModule { }
